/*
 * Package: WebVideo.CustomerPerson
 * Version: $Id$
 * Copyright (c) 2011 Sergey Leonov
 */

function CustomerPerson() {}

CustomerPerson.FIELD_CUSTOM_PREFIX = "customer_custom_";

CustomerPerson.getFBConnectionUrl = function (login_redirect_url) {
  var _url = Config.exec + "/login/facebook";
  _url += "?" + CustomerPerson.FIELD_CUSTOM_PREFIX + "time_zone=" + TimeUtils.getTzNameByLocation(Config.location, Config.defaultTimezone);
  if (login_redirect_url != null) {
    _url += "&login_redirect_url=" + encodeURI(login_redirect_url);
  }
  return _url;
};


CustomerPerson.initFBLogin = function (login_redirect_url) {
  FB.login(function(response) {
    if (response.status == 'connected') {
      document.location.href = CustomerPerson.getFBConnectionUrl(login_redirect_url);
    }
  }, {perms:'email,user_birthday,user_about_me,user_photos'});
};


CustomerPerson.submitJoinForm = function (form) {
  //screen name
  if (form.elements["customer_screen_name"].type == "hidden") {
    form.elements["customer_screen_name"].value = form.elements["customer_name"].value;
  }
  //password
  if (form.elements["customer_password_retry"].type == "hidden") {
    form.elements["customer_password_retry"].value = form.elements["customer_password"].value;
  }
  //time zone
  form.elements[CustomerPerson.FIELD_CUSTOM_PREFIX + "time_zone"].value = TimeUtils.getTzNameByLocation(Config.location, Config.defaultTimezone);
  return true;
};

CustomerPerson.submitSearchForm = function (form) {
  //age
  var age_from = 18,
      age_to = 999,
      _age_from = parseInt(form.elements['_age_from'].value),
      _age_to = parseInt(form.elements['_age_to'].value);

  if (!isNaN(_age_from) && _age_from != 0) age_from = _age_from;
  if (!isNaN(_age_to) && _age_to != 0) age_to = _age_to;
  form.elements["performer_custom_interval_age"].value = age_from + '|' + age_to;
  //
  return true;
};

CustomerPerson.submitPaidPrivateMessageForm = function (frm) {
  var form = jQuery(frm);
  var formResultContainer = jQuery(form).find(".result");
  var formErrors = new Array();
  var req_data = {
    "command": "customer-send-ppm"
  };
  //serialize && validate
  var arr = form.serializeArray();
  for (var i=0; i<arr.length; i++) {
    var value = jQuery.trim(arr[i].value);
    if (value.length == 0) {
      formErrors[formErrors.length] = I18n.t("All fields are required.");
      break;
    } else {
      var k = arr[i].name;
      req_data[k] = value;
    }
  }
  //error
  if (formErrors.length != 0) {
    formResultContainer.html("<span class=\"warning\">" + formErrors[0] + "</span>");
    return false;
  }
  //submit
  jQuery.ajax({
    "url": Config.exec+"/_ajaj-webvideo-gateway.jsp",
    "type": "POST",
    "cache": false,
    "data": req_data,
    "dataType": "json",
    "success": function(obj) {
      if (obj.res) {
        formResultContainer.html("<span class=\"note\">" + obj.msg + "</span>");
        frm.reset();
        if (typeof(SiteUtils) == "function") SiteUtils.reduceAccountBalance(obj.amount);
      } else {
        formResultContainer.html("<span class=\"warning\">" + obj.msg + "</span>");
      }
    },
    "error": function() {
      formResultContainer.html("<span class=\"error\">" + I18n.t("Connection timeout. Please try later.") + "</span>");
    }
  });
  return false;
};

CustomerPerson.addFavorite = function (performerId, foreignSiteId, add_block_id, del_block_id) {
  jQuery.getJSON(Config.exec + "/models/addFavorite/" + performerId + "/" + foreignSiteId,
    {"JsHttpRequest": (new Date()).getTime()},
    function(data) {
      if (add_block_id != null && del_block_id != null) {
        jQuery("#" + add_block_id).hide();
        jQuery("#" + del_block_id).show();
      } else {
        document.location.reload();
      }
  });
};

CustomerPerson.removeFavorite = function (performerId, foreignSiteId, add_block_id, del_block_id) {
  jQuery.getJSON(Config.exec + "/models/removeFavorite/" + performerId + "/" + foreignSiteId,
    {"JsHttpRequest": (new Date()).getTime()},
    function(data) {
      if (add_block_id != null && del_block_id != null) {
        jQuery("#" + del_block_id).hide();
        jQuery("#" + add_block_id).show();
      } else {
        document.location.reload();
      }
  });
};